// Demo-mode configuration.
//
// The static portfolio demo runs the real client with NO backend. A build-time
// flag (`VITE_DEMO_MODE`) turns on a fetch shim that either:
//   - 'replay' : answers every /api request from recorded JSON fixtures, or
//   - 'record' : passes requests through to a real local backend and captures
//                the responses so they can be saved as fixtures.
//
// When the flag is unset the whole demo layer is inert (see installDemo), so a
// normal production build is completely unaffected.
//
// Wired up via Vite's `--mode`:
//   - `vite build --mode demo`        -> .env.demo        (VITE_DEMO_MODE=replay)
//   - `vite --mode demo-record`       -> .env.demo-record (VITE_DEMO_MODE=record)

export type DemoMode = 'off' | 'replay' | 'record';

const raw = String(import.meta.env.VITE_DEMO_MODE ?? '').trim().toLowerCase();

export const DEMO_MODE: DemoMode =
  raw === 'record'
    ? 'record'
    : raw === 'replay' || raw === 'true' || raw === '1'
      ? 'replay'
      : 'off';

export const IS_DEMO = DEMO_MODE !== 'off';
export const IS_DEMO_REPLAY = DEMO_MODE === 'replay';
export const IS_DEMO_RECORD = DEMO_MODE === 'record';

// Path of the recorded fixtures bundle, served from the static host root.
export const FIXTURES_URL = '/demo-fixtures.json';
